import type { StoreId } from "@KassaroAB/shared/types/ids";
import { HELP_SITE_URL } from "../constants/api";

const helpOrigin = new URL(HELP_SITE_URL).origin;

export const helpSiteUrl = (path: string, storeId: StoreId | null): string => {
  const url = new URL(path === "/" ? "/" : path, helpOrigin);
  if (storeId) {
    url.searchParams.set("store", storeId);
  }
  return url.toString();
};

export const isAllowedHelpRedirect = (value: string | null): value is string => {
  if (!value || !URL.canParse(value)) {
    return false;
  }
  const url = new URL(value);
  if (url.origin === helpOrigin) {
    return true;
  }
  return (
    (url.hostname === "localhost" || url.hostname === "127.0.0.1") &&
    import.meta.env.VITE_ENVIRONMENT !== "prod"
  );
};

export const safeReturnTo = (value: string | null): string =>
  value && /^\/(?![/\\])/.test(value) ? value : "/";
